import { createIcon } from './factory'
import Icon from './gear.svg?react'

export const Gear = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
